export enum FinancingType {
  ABS_CREDIT_SUISSE_1 = 'abs_creditsuisse_1',
  FINN = 'finn',
}

export enum ContractTermType {
  OPEN = 'open-ended',
  FIXED = 'fixed',
}
